import React, { ReactElement } from 'react'
import EasyToSetupContainer, {
  SetupStep,
} from 'components/Organization/Industries/Common/EasyToSetupContainer'

export default function EasyToSetup(): ReactElement {
  return (
    <EasyToSetupContainer
      title="Easy to setup. Easy to onboard."
      subTitle="Setting up Control D is easy and requires no special equipment."
      question="Already using another filtering solution?"
      suggestion="Migrate to Control D effortlessly."
    >
      <SetupStep
        order={1}
        title="Activate Your Account"
        description="Sign up and activate your account"
      />
      <SetupStep
        order={2}
        title="Customize Filtering Policies"
        description="Control access based on category, age group, or custom block lists."
      />
      <SetupStep
        order={3}
        title="Deploy in Minutes"
        description="Integrate with your favorite RMM tool for fast deployment."
      />
      <SetupStep
        order={4}
        title="Monitor & Report"
        description="Get real-time analytics, audit logs, and compliance reports."
      />
    </EasyToSetupContainer>
  )
}
